import { render, staticRenderFns } from "./RequestStatus.vue?vue&type=template&id=d72d1d5e&"
import script from "./RequestStatus.vue?vue&type=script&lang=js&"
export * from "./RequestStatus.vue?vue&type=script&lang=js&"
import style0 from "./RequestStatus.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports